import { r4Client, r4Error } from '@/services'

const PostalCodesApi = {

  async search (searchTerm) {
    try {
      const resp = await r4Client().get('/api/v1/query_engine/postal_codes', { params: { term: searchTerm } })
      return resp.data
    } catch (error) {
      // wrap it in an r4 error
      throw r4Error(error)
    }
  }
}

export default PostalCodesApi
